import { useMutation } from "react-query";
import { clientsApi } from "frontend/src/api/clients";
import { notify } from "frontend/src/features/notifications";
import { queryClient } from "frontend/src/domain/query-client";
import { clientsCacheKey } from "./shared";
export var useCreateClient = function () {
    return useMutation(clientsApi.create, {
        onSuccess: function (client, variables) {
            notify({ variant: "success", message: "Клиент создан." });
            if (variables.sendAccess) {
                clientsApi
                    .sendAccess(client.id)
                    .then(function () {
                    notify({ variant: "success", message: "Доступ отправлен." });
                })
                    .catch(function () {
                    notify({
                        variant: "error",
                        message: "Клиент создан, но доступ отправить не удалось.",
                    });
                });
            }
        },
        onSettled: function () { return queryClient.invalidateQueries(clientsCacheKey); },
    });
};
export var useUpdateClient = function (clientId) {
    return useMutation(function (request) {
        return clientsApi.update(clientId, request);
    }, {
        onSuccess: function () {
            notify({ variant: "success", message: "Клиент обновлен." });
        },
        onSettled: function () { return queryClient.invalidateQueries(clientsCacheKey); },
    });
};
export var useAddClientSite = function (clientId) {
    return useMutation(function (request) {
        return clientsApi.addSite(clientId, request);
    }, {
        onSuccess: function () {
            notify({ variant: "success", message: "Адрес добавлен." });
        },
        onSettled: function () { return queryClient.invalidateQueries(clientsCacheKey); },
    });
};
export var useDeleteClientSite = function (clientId) {
    return useMutation(function (siteId) { return clientsApi.deleteSite(clientId, siteId); }, {
        onSuccess: function () {
            notify({ variant: "success", message: "Адрес удален." });
        },
        onSettled: function () { return queryClient.invalidateQueries(clientsCacheKey); },
    });
};
export var useDeleteClientActivityLogFile = function () {
    return useMutation(function () { return clientsApi.deleteActivityLogFile(); }, {
        onSuccess: function () {
            notify({
                variant: "success",
                message: "Лог отправлен на почту и удален.",
            });
        },
        onSettled: function () {
            return queryClient.invalidateQueries([clientsCacheKey, "activity-log-file"]);
        },
    });
};
export var useSendClientAccess = function (clientId) {
    return useMutation(function () { return clientsApi.sendAccess(clientId); }, {
        onSuccess: function () {
            notify({ variant: "success", message: "Доступ отправлен." });
        },
        onError: function () {
            notify({
                variant: "error",
                message: "Не удалось отправить доступ.",
            });
        },
        onSettled: function () { return queryClient.invalidateQueries([clientsCacheKey, clientId]); },
    });
};
